import { z } from 'zod';

// ── Ticket Exit schemas (JQ4-17 · US-CONFIG-003) ─────────────────────────────
//
// These schemas define the contract for vehicle exit/re-entry registration
// on Hotel-niche tickets. Used by the PWA valet app and backend use cases.

// ── RegisterTicketExitRequest ─────────────────────────────────────────────────
//
// Body for POST /valet/tickets/:ticketId/exits.
// Currently has no required fields — the action is implicit (register exit now).
// Reserved for future optional metadata (e.g. notes, zone override).

export const RegisterTicketExitRequestSchema = z.object({
  notes: z.string().trim().max(500).optional(),
});

export type RegisterTicketExitRequest = z.infer<typeof RegisterTicketExitRequestSchema>;

// ── RegisterReentryRequest ────────────────────────────────────────────────────
//
// Body for PATCH /valet/tickets/:ticketId/exits/latest/re-entry.
// Closes the most-recent open TicketExit (where reentryAt is null).

export const RegisterReentryRequestSchema = z.object({
  notes: z.string().trim().max(500).optional(),
});

export type RegisterReentryRequest = z.infer<typeof RegisterReentryRequestSchema>;

// ── TicketExitResponse ────────────────────────────────────────────────────────

export const TicketExitResponseSchema = z.object({
  id: z.string().uuid(),
  ticketId: z.string().uuid(),
  sequence: z.number().int().positive(),
  exitAt: z.string().datetime(),
  reentryAt: z.string().datetime().nullable(),
  /** Derived: true when reentryAt is null (vehicle currently out). */
  vehicleOut: z.boolean(),
  /** Fee charged for this exit event, in cents. 0 for unlimited/max_exits policies. */
  exitFeeCents: z.number().int().nonnegative(),
});

export type TicketExitResponse = z.infer<typeof TicketExitResponseSchema>;

// ── TicketExitListResponse ────────────────────────────────────────────────────

export const TicketExitListResponseSchema = z.array(TicketExitResponseSchema);

export type TicketExitListResponse = z.infer<typeof TicketExitListResponseSchema>;
